export default __webpack_public_path__ + "static/media/carousel40logo.2efc7305.png";